import { use as Pe, insert as S, createComponent as f, mergeProps as z, memo as Be, effect as Ne, className as me, style as Ee, template as be } from "solid-js/web";
import { createSignal as w, onMount as Ie, createEffect as ye, Show as k } from "solid-js";
import { handleDateRange as pe } from "../../../node_modules/.pnpm/@rnwonder_simple-datejs@1.0.4/node_modules/@rnwonder/simple-datejs/dist/datePicker.js";
import { convertDateObjectToDate as W, convertDateToDateObject as ve } from "../../../node_modules/.pnpm/@rnwonder_simple-datejs@1.0.4/node_modules/@rnwonder/simple-datejs/dist/utils.js";
import { CalendarArea as He } from "../CalendarArea/index.js";
import { DatePickerTop as Ve } from "../DatePickerTop/index.js";
import Le from "../SelectorTwo/index.js";
import { s as De, f as q, k as ze, o as we, e as We } from "../../../node_modules/.pnpm/@rnwonder_simple-datejs@1.0.4/node_modules/@rnwonder/simple-datejs/dist/general-BkFCKlQ-.js";
import { cn as fe } from "../../utils/class.js";
var Se = be("<div data-type=custom-jsx>"), qe = be("<div data-type=date-picker-wrapper data-scope=date-picker data-part=content role=application aria-label=calendar aria-roledescription=date-picker><div>");
const tt = (e) => {
  const [b, p] = w((/* @__PURE__ */ new Date()).getMonth()), [O, v] = w(De), [M, T] = w(), [X, G] = w(void 0), [j, H] = w([]), [K, P] = w(!0), [Me, Q] = w(!1), [A, C] = w({}), [Ce, Ye] = w([]);
  Ie(() => {
    var t, r, n, s, l, u, c, i, x, F, J, R, m, h, y, E, te, re, ae, ne, oe, le, se, ce, ue, ie, he;
    if (!((t = e.value) != null && t.selected || (r = e.value) != null && r.start || (n = e.value) != null && n.end || (s = e.value) != null && s.selectedDateObject || (l = e.value) != null && l.startDateObject || (u = e.value) != null && u.endDateObject || (c = e.value) != null && c.multiple || (x = (i = e.value) == null ? void 0 : i.multipleDateObject) != null && x.length))
      return (F = e.month) != null && F.call(e) || ((J = e.setMonth) == null || J.call(e, (/* @__PURE__ */ new Date()).getMonth())), (R = e.year) != null && R.call(e) || ((m = e.setYear) == null || m.call(e, De)), void U();
    if (U(), Q(!0), e.value.selected || e.value.selectedDateObject) {
      const o = e.value.selected ? new Date(e.value.selected) : W(e.value.selectedDateObject);
      p(o.getMonth()), (h = e.setMonth) == null || h.call(e, o.getMonth()), v(o.getFullYear()), (y = e.setYear) == null || y.call(e, o.getFullYear()), T({ year: o.getFullYear(), month: o.getMonth(), day: o.getDate() });
    }
    if (e.value.start || e.value.end || e.value.startDateObject || e.value.endDateObject) {
      const o = e.value.start ? new Date(e.value.start) : (E = e.value.startDateObject) != null && E.day ? W(e.value.startDateObject) : void 0, a = e.value.end ? new Date(e.value.end) : (te = e.value.endDateObject) != null && te.day ? W(e.value.endDateObject) : void 0;
      if (!o && !a)
        return;
      if (!o && a) {
        p(a.getMonth()), (re = e.setMonth) == null || re.call(e, a.getMonth()), v(a.getFullYear()), (ae = e.setYear) == null || ae.call(e, a.getFullYear());
        const ge = { year: a.getFullYear(), month: a.getMonth(), day: a.getDate() };
        return T(ge), void C({ start: ge });
      }
      p(o.getMonth()), (ne = e.setMonth) == null || ne.call(e, o.getMonth()), v(o.getFullYear()), (oe = e.setYear) == null || oe.call(e, o.getFullYear());
      const I = { year: o.getFullYear(), month: o.getMonth(), day: o.getDate() };
      if (T(I), C({ start: I }), !a)
        return;
      G({ year: a.getFullYear(), month: a.getMonth(), day: a.getDate() }), C({ start: void 0 }), e.showEndOfRange && (p(a.getMonth()), (le = e.setMonth) == null || le.call(e, a.getMonth()), v(a.getFullYear()), (se = e.setYear) == null || se.call(e, a.getFullYear()));
    }
    if ((ce = e.value.multipleDateObject) != null && ce.length || e.value.multiple) {
      const o = (ue = e.value.multipleDateObject) != null && ue.length ? e.value.multipleDateObject : e.value.multiple ? e.value.multiple.map((I) => ve(new Date(I))) : void 0;
      if (!o)
        return;
      H(o);
      const a = o.at(-1);
      a != null && a.month && (p(a.month), (ie = e.setMonth) == null || ie.call(e, a.month)), a != null && a.year && (v(a.year), (he = e.setYear) == null || he.call(e, a.year));
    }
  });
  const B = (t) => {
    var r, n;
    e.handleOnChange(t), (r = e == null ? void 0 : e.onChange) == null || r.call(e, t), (n = e.onValueChange) == null || n.call(e, t);
  }, U = () => {
    var t, r;
    e.startingMonth && p(e.startingMonth), e.startingMonth && ((t = e.setMonth) == null || t.call(e, e.startingMonth)), e.startingYear && v(e.startingYear), e.startingYear && ((r = e.setYear) == null || r.call(e, e.startingYear));
  };
  ye(() => {
    K() || P(!0);
  });
  const Z = (t, r, n, s = !1) => {
    var i, x, F, J, R;
    Me() || Q(!0);
    const l = Number(r()), u = q(l, t.month), c = ze(n(), r(), t.month);
    if (e.type === "range") {
      const { end: m, start: h, initial: y } = pe({ day: t, month: r, year: n, endDay: X(), startDay: M(), disabledDays: e.disabledDays, enabledDays: e.enabledDays, disallowSameDayRange: e.disallowSameDayRange });
      T(h), G(m), y && !e.disableRangeHoverEffect && C({ start: h, end: void 0 }), m && h && (C({}), e.shouldCloseOnSelect && ((i = e.close) == null || i.call(e))), B({ startDate: h, endDate: m, type: "range" });
    }
    if (e.type === "single") {
      const m = new Date(c, q(l, t.month), t.value), h = ve(m);
      T(h), B({ selectedDate: h, type: "single" }), e.shouldCloseOnSelect && ((x = e.close) == null || x.call(e));
    }
    if (e.type === "multiple") {
      const m = { year: c, month: q(l, t.month), day: t.value }, h = j().find((y) => we(y, m));
      if (h) {
        const y = j().filter((E) => !we(E, h));
        return H(y), void B({ multipleDates: y, type: "multiple" });
      }
      H((y) => [...y, m]), B({ multipleDates: j(), type: "multiple" }), e.shouldCloseOnSelect && ((F = e.close) == null || F.call(e));
    }
    s || (p(u), (J = e.setMonth) == null || J.call(e, u), v(c), (R = e.setYear) == null || R.call(e, c)), P(!1);
  }, N = (t, r) => {
    var s, l, u, c, i;
    p(t), (s = e.setMonth) == null || s.call(e, t), (l = e.onMonthChange) == null || l.call(e, t), r && (v(r), (u = e.setYear) == null || u.call(e, r), (c = e.onYearChange) == null || c.call(e, r));
    const n = We({ startDay: M(), month: t, year: r, type: e.type });
    n && ((i = e.onValueChange) == null || i.call(e, n));
  }, _ = () => {
    var r, n;
    if ((((r = e.month) == null ? void 0 : r.call(e)) || b()) === 11) {
      const l = O() + 1;
      return void N(0, l);
    }
    const t = (((n = e.month) == null ? void 0 : n.call(e)) || b()) + 1;
    N(t), P(!1);
  }, $ = () => {
    var r, n;
    if ((((r = e.month) == null ? void 0 : r.call(e)) || b()) === 0) {
      const l = O() - 1;
      return void N(11, l);
    }
    const t = (((n = e.month) == null ? void 0 : n.call(e)) || b()) - 1;
    N(t), P(!1);
  }, Te = (t, r, n) => {
    var u, c, i;
    if (e.disableRangeHoverEffect || e.type !== "range" || !((u = A()) != null && u.start))
      return;
    const { end: s, start: l } = pe({ day: t, month: r, year: n, endDay: (c = A()) == null ? void 0 : c.end, startDay: (i = A()) == null ? void 0 : i.start, disabledDays: e.disabledDays, hover: !0, enabledDays: e.enabledDays });
    C({ start: l, end: s });
  }, ke = () => {
    var t;
    e.disableRangeHoverEffect || e.type === "range" && ((t = A()) != null && t.start) && (M() && X() || C({ start: M(), end: void 0 }));
  }, g = (t) => {
    if (t) {
      if (typeof t == "function") {
        const [s, l] = w();
        ye(() => {
          var c;
          s() && ((c = e.setAllowedComponents) == null || c.call(e, (i) => [...i, s()]));
        });
        const u = t({ month: b, setMonth: p, handleNextMonth: _, handlePrevMonth: $, year: O, setYear: v, setRefToAllowOutsideClick: l, handleDayClick: Z, multipleDates: j, endDate: X, selectedDate: M, close: e.close });
        return r = Se(), S(r, u), r;
      }
      var r, n;
      return n = Se(), S(n, t), n;
    }
  }, Oe = g(e.monthSelectorJSX), je = g(e.yearSelectorJSX), Ae = g(e.calendarTopAreaJSX), V = g(e.calendarLeftAreaJSX), L = g(e.calendarRightAreaJSX), d = g(e.calendarBottomAreaJSX), xe = g(e.calendarJSX), Fe = g(e.afterNextButtonAreaJSX), Je = g(e.beforePrevButtonAreaJSX), Re = g(e.weekDaysJSX), Xe = g(e.calendarAboveTopAreaJSX);
  return D = qe(), Y = D.firstChild, typeof (ee = e.setRef) == "function" ? Pe(ee, D) : e.setRef = D, S(D, f(k, { get when() {
    var t;
    return (t = e.showSelectorTwo) == null ? void 0 : t.call(e);
  }, get children() {
    return f(Le, z(() => {
      var t;
      return (t = e.selectorTwoProps) == null ? void 0 : t.call(e);
    }, { get monthSelectorTopLabel() {
      return e.monthSelectorTopLabel;
    }, get setShowSelectorTwo() {
      return e.setShowSelectorTwo;
    }, get setSelectorTwoProps() {
      return e.setSelectorTwoProps;
    } }));
  } }), Y), S(D, f(k, { get when() {
    return !e.hideTopArea;
  }, keyed: !0, get children() {
    return [Xe, Be(() => Ae || f(Ve, z(() => ({ ...e, onChange: void 0 }), { get setYear() {
      return e.setYear || v;
    }, get setMonth() {
      return e.setMonth || p;
    }, get month() {
      return e.month || b;
    }, get year() {
      return e.year || O;
    }, render: K, handleNextMonth: _, handlePrevMonth: $, monthSelectorJSX: Oe, yearSelectorJSX: je, get zIndex() {
      return e.zIndex;
    }, get setAllowedComponents() {
      return e.setAllowedComponents;
    }, get monthSelectorFormat() {
      return e.monthSelectorFormat;
    }, get monthYearSelectorFlexDirection() {
      return e.monthYearSelectorFlexDirection;
    }, get onChange() {
      return e.onValueChange;
    }, get startDay() {
      return M();
    }, setStartDay: T, get yearRange() {
      return e.yearRange;
    }, get locale() {
      return e.locale;
    }, get nextIcon() {
      return e.nextIcon;
    }, get prevIcon() {
      return e.prevIcon;
    }, get removeNavButtons() {
      return e.removeNavButtons;
    }, nextButtonAreaJSX: Fe, prevButtonAreaJSX: Je, get primaryColor() {
      return e.primaryColor;
    }, get primaryTextColor() {
      return e.primaryTextColor;
    }, get secondaryColor() {
      return e.secondaryColor;
    }, get secondaryTextColor() {
      return e.secondaryTextColor;
    }, get setShowSelectorTwo() {
      return e.setShowSelectorTwo;
    }, get setSelectorTwoProps() {
      return e.setSelectorTwoProps;
    }, get showSelectorTwo() {
      return e.showSelectorTwo;
    } })))];
  } }), Y), S(Y, f(k, { get when() {
    var t;
    return V && !((t = e.showSelectorTwo) != null && t.call(e));
  }, keyed: !0, children: V }), null), S(Y, f(k, { get when() {
    return !e.hideCalendar;
  }, keyed: !0, get children() {
    return xe || f(He, z(e, { get year() {
      return e.year || O;
    }, get month() {
      return e.month || b;
    }, endDay: X, startDay: M, handleDayClick: Z, multipleObject: j, weekDaysJSX: Re, onHoverDay: Te, hoverRangeValue: A, onHoverDayEnd: ke, get showSelectorTwo() {
      return e.showSelectorTwo;
    }, setDayRowsArray: Ye, dayRowsArray: Ce }));
  } }), null), S(Y, f(k, { get when() {
    var t;
    return L && !((t = e.showSelectorTwo) != null && t.call(e));
  }, keyed: !0, children: L }), null), S(D, f(k, { get when() {
    var t;
    return d && !((t = e.showSelectorTwo) != null && t.call(e));
  }, keyed: !0, children: d }), null), Ne((t) => {
    var l;
    var r = fe(`date-picker-wrapper 
          rn-relative 
          rn-rounded-md 
          rn-border-t 
          rn-border-solid
          rn-border-gray-300
          rn-bg-white
          rn-pb-[0.5rem] 
          rn-pt-[0.625rem] 
          dark:rn-border-gray-700
          dark:rn-bg-dreamless-sleep
          `, { "rn-w-max": !V && !L, "rn-shadow-lg": !((l = e.showSelectorTwo) != null && l.call(e)) }, e.datePickerWrapperClass), n = { ...e.backgroundColor && { "background-color": e.backgroundColor } }, s = fe("date-picker-body rn-flex rn-justify-center", e.datePickerBodyAreaClass);
    return r !== t.e && me(D, t.e = r), t.t = Ee(D, n, t.t), s !== t.a && me(Y, t.a = s), t;
  }, { e: void 0, t: void 0, a: void 0 }), D;
  var D, Y, ee;
};
export {
  tt as DatePicker
};
